import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Header() {
  const { i18n } = useTranslation();
  const { t } = useTranslation()

  const users = 2500;
  const deger = (users / 4000) * 100 - 9 + "%";

  const changeLanguage = () => {
    const currentLang = i18n.language || "tr";
    const newLang = currentLang === "en" ? "tr" : "en";
    i18n.changeLanguage(newLang);
  };

  return (
    <>
      <div className="divider rotate"></div>
      <div
        id="myCarousel"
        className="carousel slide carousel-fade"
        data-ride="carousel">
        <div className="carousel-inner" role="listbox">
          <div className="item active">
            <img src="assets/images/header_slide_1.jpg" alt="" />
          </div>
          <div className="item">
            <img src="assets/images/header_slide_2.jpg" alt="" />
          </div>
        </div>
        <div className="navbar-wrapper">
          <nav className="navbar navbar-inverse navbar-static-top">
            <div className="container">
              <div className="navbar-header">
                <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#navbar"
                  aria-expanded="false"
                  aria-controls="navbar">
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
                <button
                  type="button"
                  className="login-button-mobil"
                  data-toggle="modal"
                  data-target="#login_modal">
                  {t("girisYap")}
                </button>
                <Link to="/register" className="reg-button-mobil">
                  {t("kayitOl")}
                </Link>
              </div>
            </div>
            <div className="container flex-s-c">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  changeLanguage();
                }}
                href="#!"
                className="lang-block flex"
                data-toggle="tooltip"
                data-placement="left"
                title={
                  i18n.language === "en"
                    ? "Türkçe'ye çevir"
                    : "Switch to English"
                }>
                <img
                  src={
                    i18n.language === "en"
                      ? "assets/images/tr-icon.png" // İngilizceyse Türk bayrağı göster
                      : "assets/images/eng-icon.png" // Türkçeyse İngiliz bayrağı göster
                  }
                  alt="language icon"
                />
              </a>
              <div
                id="navbar"
                className="navbar-collapse collapse"
                aria-expanded="false"
                style={{ height: "1px" }}>
                <ul className="nav navbar-nav top-menu">
                  <li className="active">
                    <Link to="/" className="home-icon">
                      {t("anasayfa")}
                    </Link>
                  </li>

                  <li className="dropdown">
                    <a
                      href="#!"
                      className="dropdown-toggle rank-icon"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={(e) => e.preventDefault()}>
                      {t("siralama")} <span className="caret"></span>
                    </a>
                    <ul className="dropdown-menu">
                      <li className="sub">
                        <Link to="/user-rank" className="sub">
                          <i
                            className="fas fa-user menu-icon"
                            aria-hidden="true"></i>
                          {t("oyuncuSiralamasi")}
                        </Link>
                      </li>
                      <li className="sub">
                        <Link to="/clan-rank" className="sub">
                          <i
                            className="fas fa-users menu-icon"
                            aria-hidden="true"></i>
                          {t("klanSiralamasi")}
                        </Link>
                      </li>
                      <li className="sub">
                        <Link
                          to="/banned-users"
                          href="banned-user"
                          className="sub">
                          <i className="fas fa-user-slash menu-icon"></i>
                          {t("yasaklİOyuncular")}
                        </Link>
                      </li>
                      <li className="sub">
                        <Link
                          to="/kingdom-elections"
                          href="kingdom-elections"
                          className="sub">
                          <i
                            className="fas fa-crown menu-icon"
                            aria-hidden="true"></i>
                          {t("krallikSecimleri")}
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="dropdown">
                    <a
                      href="#!"
                      className="dropdown-toggle guide-icon"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={(e) => e.preventDefault()}>
                      {t("rehber")} <span className="caret"></span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <Link to="/upgrade-rates" className="sub">
                          <i className="fas fa-chart-line menu-icon"></i>
                          {t("upgradeOranlari")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/mining-fishing" className="sub">
                          <i className="fas fa-fish menu-icon"></i>
                          {t("madenVeBalikcilik")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/fragment-gem" className="sub">
                          <i className="fas fa-gem menu-icon"></i>
                          {t("fragmentVeGemler")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/drop-search" className="sub">
                          <i className="fas fa-search menu-icon"></i>
                          {t("dropArama")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/achievement" className="sub">
                          <i className="fas fa-trophy menu-icon"></i>
                          {t("achievement")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/shozin-tutorial" className="sub">
                          <i className="fas fa-tasks menu-icon"></i>
                          {t("shozinTutorial")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/event-awards" className="sub">
                          <i className="fas fa-calendar-alt menu-icon"></i>
                          {t("etkinlikTakvimi")}
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="dropdown">
                    <a
                      href="#!"
                      className="dropdown-toggle pus-icon"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={(e) => e.preventDefault()}>
                      {t("pus")} <span className="caret"></span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <Link to="/reseller" className="sub">
                          <i className="fas fa-store menu-icon"></i>{" "}
                          {t("yetkiliBayi")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/products" className="sub">
                          <i className="fas fa-shopping-cart menu-icon"></i>{" "}
                          {t("urunler")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/premiums" className="sub">
                          <i className="fas fa-gifts menu-icon"></i>{" "}
                          {t("premiumlar")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/packages" className="sub">
                          <i className="fas fa-gifts menu-icon"></i>{" "}
                          Paketler
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="dropdown">
                    <a
                      href="#!"
                      className="dropdown-toggle media-icon"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={(e) => e.preventDefault()}>
                      {t("medya")} <span className="caret"></span>
                    </a>
                    <ul className="dropdown-menu">
                      <li>
                        <Link to="/images" className="sub">
                          <i className="fas fa-image menu-icon"></i>
                          {t("resimler")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/movie" className="sub">
                          <i className="fas fa-video menu-icon"></i>
                          {t("videolar")}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a
                      href="https://forum.knightkingdom.net/"
                      className="forum-icon"
                      target="_blank"
                      rel="noopener noreferrer">
                      {t("forum")}
                    </a>
                  </li>
                  <li>
                    <Link
                      to="/turnuvalar"
                      href="turnuvalar"
                      className="turnuva-icon">
                      {t("turnuvalar")}
                    </Link>
                  </li>
                </ul>
                <Link to="/user-cp">
                  <button type="button" className="modal-button">
                    PANEL
                  </button>
                </Link>
                <Link to="/">
                  <button type="button" className="modal-button mx-2">
                    {t("cikis")}
                  </button>
                </Link>
                <button
                  type="button"
                  className="modal-button red"
                  data-toggle="modal"
                  data-target="#login_modal">
                  {t("girisKayit")}
                </button>
              </div>
            </div>
          </nav>
        </div>
        <header className="heragame">
          <div className="container">
            <div className="logo">
              <Link to="/">
                <img src="assets/images/logo.png" alt="" />
              </Link>
            </div>
            <div className="user-counter">
              <div className="user-block flex">
                <div className="user-online">
                  500<span>USER</span>
                </div>
                <div className="user-online">
                  1K<span>USER</span>
                </div>
                <div className="user-online">
                  2K<span>USER</span>
                </div>
                <div className="user-online">
                  3K<span>USER</span>
                </div>
                <div className="user-online">
                  4K<span>USER</span>
                </div>
              </div>
              <div className="counter-block">
                <img
                  style={{ width: deger }}
                  src="assets/images/progress-bar.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </header>
        <input
          type="text"
          name="otomatikDoldurma"
          id="otomatikDoldurma"
          value=""
          style={{ display: "none" }}
        />
        <input
          type="password"
          name="sahte_parola"
          id="sahte_parola"
          value=""
          style={{ display: "none" }}
        />
        <div className="divider"></div>
      </div>
      <Outlet />

      {/* Üye Girişi Modal */}
      <div className="modal fade" id="login_modal" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
              <h4 className="modal-title">{t("uyeGirisi")}</h4>
            </div>
            <div className="modal-body">
              <div className="modal-login">
                <p>
                  <span className="form-title">{t("hesapId")}</span>
                </p>
                <div className="input-group">
                  <span className="input-group-addon" id="basic-addon1">
                    <i className="fas fa-user"></i>
                  </span>
                  <input
                    id="userid"
                    type="text"
                    className="form-control"
                    placeholder=""
                    aria-describedby="basic-addon1"
                    required
                  />
                </div>

                <p>
                  <span className="form-title mt-15">{t("parola")}</span>
                </p>
                <div className="input-group">
                  <span className="input-group-addon" id="basic-addon1">
                    <i className="fas fa-key"></i>
                  </span>
                  <input
                    id="pass"
                    type="password"
                    className="form-control"
                    placeholder=""
                    aria-describedby="basic-addon1"
                    required
                  />
                </div>

                <Link to="/">
                  <button className="modal-button red mt-15" >
                    {t("girisYap")}
                  </button>
                </Link>

                <Link to="/forgot-password" style={{ float: "right" }}>
                  <button className="modal-button red mt-15">
                    {t("sifreSifirla")}
                  </button>
                </Link>

                <label id="mesaj" className="control-label"></label>

                <div className="mt-15">
                  <button style={{background:"transparent" , border:"none"}}>
                    <Link to="/forgot-password">{t("sifremiUnuttumSoru")}</Link>

                  <span>
                    {" "}
                    {t("hesabinizYokMu")}{" "}
                    <Link to="/register">{t("hemenKayitOl")}</Link>
                  </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
